{
  "notifications": {
    "checkInAtAirport": ""
  },
  "apis": {
    "form": {
      "passport": {
        "scanUploadTitle": "Skannaa tai lataa passisi"
      }
    }
  },
  "checkIn": {
    "steps": {
      "apis": {
        "usePassportOnlyNotification": {
          "title": "Using a different form of ID instead of a passport?",
          "content": "Please check in at the airport counter with all the necessary documents.\n\n"
        },
        "infoBox": {
          "ensureDetailsComplete": "Varmista, että tarvittavat tiedot on annettu ja että ne ovat oikein",
          "documentsPreChecked": "Matkustusasiakirjat on vahvistettu",
          "documentsNotChecked": "",
          "seeAgentOrPreCheck": "Asiakirjasi tarkistetaan lentokentällä.",
          "seeAgentOrPreCheckButton": "Vahvista verkossa ja säästä aikaa"
        }
      }
    }
  },
  "promotion": {
    "goToAirlineCheckIn": {
      "content": "Vähintään yhdellä lennoistasi on eri lentoyhtiö. Tee lähtöselvitys tämän yhtiön verkkosivuilla tai lentoaseman lähtöselvitystiskillä.",
      "title": "Tee lähtöselvitys liikennöivän lentoyhtiön sivuilla"
    }
  }
}
